<template>
  <div>
    <tabs v-if="tabs && tabs.length > 0">
      <tabs-item
        v-for="(tab, key) in tabs"
        :key="key"
        :active="key === activeTab"
        @click="setActiveTab(tab)"
        >{{ tab.title }}</tabs-item
      >
    </tabs>

    <h1>Notification preferences</h1>
    <p>
      Here you can manage your preferences for receiving app and desktop
      notifications.
    </p>

    <accordion
      title="General settings"
      subtitle="General settings for your notifications"
      expandLink="Edit"
    >
    </accordion>
    <accordion
      title="Content types"
      subtitle="Select the types of content you want to receive notifications about"
      expandLink="Edit"
    >
      <matrix :column-titles="['Push Notification', 'Desktop Notification', 'Email']">
        <matrix-row title="News">
          <div><input type="checkbox" checked /></div>
          <div><input type="checkbox" checked /></div>
          <div><input type="checkbox" checked /></div>
        </matrix-row>
        <matrix-row title="Events">
          <div><input type="checkbox" checked /></div>
          <div><input type="checkbox" checked /></div>
          <div><input type="checkbox" checked /></div>
        </matrix-row>
        <matrix-row title="Content">
          <div><input type="checkbox" checked /></div>
          <div><input type="checkbox" checked /></div>
          <div><input type="checkbox" checked /></div>
        </matrix-row>
      </matrix>
      <p class="ta-right"><base-button @click="savePreferences" primary="true">Update Preferences</base-button></p>
    </accordion>
    <accordion
      title="Interest groups"
      subtitle="Select which interest groups you want to receive notifications about"
      expandLink="Edit"
    >
      <p v-if="userGroups.length < 1">
        You are not a member of any interest groups
      </p>
      <matrix :column-titles="['Yes', 'No']" v-else>
        <matrix-row
          :title="group.name"
          v-for="group in userGroups"
          :key="group.id"
        >
          <div><input type="radio" /></div>
          <div><input type="radio" /></div>
        </matrix-row>
      </matrix>
    </accordion>
  </div>
</template>

<script>
import { Matrix, MatrixRow } from "@/components/Containers/Matrix";
import Accordion from "@/components/Containers/BaseAccordion";
import { mapGetters, mapState } from "vuex";
import UserProfile from "@/mixins/UserProfile";

export default {
  name: "UserProfile",

  mixins: [UserProfile],

  components: {
    Accordion,
    Matrix,
    MatrixRow,
  },

  data() {
    return {
      loading: true,
    };
  },

  computed: {
    ...mapGetters("UserGroups", ["filteredUserGroups"]),
    ...mapState("InterestGroups", ["userGroups"]),
  },

  methods: {
    setActiveTab(tab) {
      this.$router.push({ path: tab.to });
    },
    updatePreferences(){
      alert("Updated")
    }
  },

  async created() {
    // if we are looking at someones specific profile, get them, else load current user
    try {
      await this.$store.dispatch("UserGroups/list");
    } catch (err) {
      console.log(
        "🚀 ~ file: Notifications.vue ~ line 129 ~ created ~ err",
        err
      );
    }
  },
};
</script>

<style lang="scss" scoped></style>
